import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';

class ErrorBox extends Component {
    render() {
        if(typeof(this.props.errorMessages) !== "undefined" && this.props.errorMessages.length > 0) {
            let errorMessageControls = this.props.errorMessages.map(e =>
                <li className="ErrorBox-errorItem">{e}</li>);

            return (
                <Panel bsStyle="danger" header={this.props.header}>
                    <ul>
                        { errorMessageControls }
                    </ul>
                </Panel>
            );
        }

        return (<span></span>);
    }
}

export default ErrorBox;


// WEBPACK FOOTER //
// ./src/components/ErrorBox.js